import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import Router from 'vue-router'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      components: {
        'header-bottom-user-notification': HeaderBottomUserNotification,
      },
    },
  ],
})
